import { render, staticRenderFns } from "./ProposalDetailsModal.vue?vue&type=template&id=d269e5e0&scoped=true&"
import script from "./ProposalDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ProposalDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./ProposalDetailsModal.vue?vue&type=style&index=0&id=d269e5e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d269e5e0",
  null
  
)

export default component.exports